<footer class="footer">
  <div class="container">
    
    <div class="main-info">
      <span class="name">Ana Pellón Mendoza</span>
      <span class="separator">|</span>
      
      <a href="https://www.google.com/maps/search/?api=1&query=Psicologia+Ana+Pellon+Mendoza&query_place_id=ChIJ94R70GpJSQ0RGa2VsYjtqEI" target="_blank" class="address" title="Ver ubicación">
        C. Rosalía de Castro, 19, 1ºB
      </a>
      <span class="separator">|</span>
      
      <span class="contact-group">
        <a href="mailto:anapellonpsicologa@gmail.com">anapellonpsicologa@gmail.com</a>
        <span class="dot">·</span>
        <a href="https://wa.link/227699" target="_blank">675 18 16 84</a>
      </span>
    </div>

    <div class="legal-info">
      <nav>
        <a routerLink="/aviso-legal">Aviso legal</a>  · 
        <a routerLink="/politica-de-cookies">Política de cookies</a>  · 
        <a routerLink="/politica-de-privacidad">Política de privacidad</a>
      </nav>
      <span class="copyright">©{{ year }} Psicología Ana Pellón Mendoza</span>
    </div>

  </div>
</footer>